// Cards are `raised` and swap in a larger shadow on hover; the biggest of the
// two reaches 12px to the sides, 6px above and 20px below the card.
export const CARD_SHADOW_BLEED = '20px';

// Containers that bound the card area but must let the shadow paint outside
// their own box. `overflowClipMargin` alone is not enough: WebKit has no
// support for it and clips flush at the box edge, cutting the shadow of any
// card sitting against that edge. That covers every browser on iOS/iPadOS —
// Chrome and Firefox there render through WebKit too, not their own engines.
export const shadowBleed = {
  overflow: 'clip',
  overflowClipMargin: CARD_SHADOW_BLEED,
  minWidth: 0,
  minHeight: 0,
};

// The innermost box holding the cards: bottom-row cards sit flush against its
// lower edge, so it must not clip at all. Its shadow spills into the page-info
// strip below, well inside the clipping ancestor.
export const shadowSpill = {
  overflow: 'visible',
  minWidth: 0,
  minHeight: 0,
};
